export const TAB_TYPE_CALENDAR = 'calendar';
export const TAB_TYPE_RADIO = 'radio';
export const TAB_TYPE_SEGMENTED = 'segmented';
export const TAB_TYPE_MENU = 'menu';
export const TAB_TYPE_MENU_FILLED = 'menu-filled';
export const TAB_TYPE_MORE = 'more';
export const TAB_TYPE_UNDERLINED = 'underlined';
export const TAB_TYPE_FILTER = 'filter';

export const TabViewTypes = [
  TAB_TYPE_CALENDAR,
  TAB_TYPE_RADIO,
  TAB_TYPE_SEGMENTED,
  TAB_TYPE_MENU,
  TAB_TYPE_MENU_FILLED,
  TAB_TYPE_MORE,
  TAB_TYPE_UNDERLINED,
  TAB_TYPE_FILTER,
];

export const TAB_OVERFLOW_SCROLL = 'scroll';
export const TAB_OVERFLOW_DROPDOWN = 'dropdown';
export const TabOverflowTypes = [TAB_OVERFLOW_SCROLL, TAB_OVERFLOW_DROPDOWN];
